import styled from '@emotion/styled';
import { Colors } from '../../common/Colors';
import { LIST_TRANSITION_DURATION_HOVER, LIST_TRANSITION_DURATION } from '../../helpers';
import { getRem } from '../../utils';

const HEIGHT_CELL = '5rem';

export const TableContainer = styled('div')`
  position: relative;
  z-index: 1;
  margin-left: -2rem;
  margin-right: -2rem;
`;

export const Table = styled('table')`
  width: 100%;
  font-size: 1.4rem;
  line-height: 1.2;
  border-spacing: 0;
`;

export const Thead = styled('thead')``;

export interface TbodyProps {
  rowHeight?: number;
}

export const Tbody = styled('tbody')<TbodyProps>`
  td {
    height: ${props => getRem(props.rowHeight) || HEIGHT_CELL};
  }

  tr:after {
    height: ${props => getRem(props.rowHeight) || HEIGHT_CELL};
  }
`;

export const Tr = styled('tr')`
  &:after {
    content: '';
    position: absolute;
    z-index: -1;
    left: 0;
    right: 0;
    background: linear-gradient(90deg, rgba(0, 0, 0, 0.05) 68%, rgba(0, 0, 0, 0) 83%);
    visibility: hidden;
    opacity: 0;
    transition-property: visibility, opacity;
    transition-duration: ${LIST_TRANSITION_DURATION};
    transition-timing-function: ease-in;
  }

  &:hover {
    &:after {
      visibility: visible;
      opacity: 1;
      transition-duration: ${LIST_TRANSITION_DURATION_HOVER};
      transition-timing-function: ease-out;
    }
  }
`;

export interface CellProps {
  width?: number;
  textAlign?: 'left' | 'right' | 'center';
}

export const Th = styled('th')<CellProps>`
  vertical-align: bottom;
  width: ${props => getRem(props.width)};
  padding: 0 2rem 0 0;
  text-align: left;
  font-weight: 400;
  font-size: 1.3rem;
  color: ${Colors.rgbaBlack50};
  text-align: ${props => props.textAlign};

  &:first-of-type {
    padding-left: 2rem;
  }

  &:after {
    content: '';
    display: block;
    height: 0;
    padding-top: 1.5rem;
    margin-right: -2rem;
    border-bottom: 1px solid ${Colors.rgbaBlack7};
  }

  &:last-child {
    &:after {
      margin-right: 0;
    }
  }
`;

export const Td = styled('td')<CellProps>`
  vertical-align: middle;
  width: ${props => getRem(props.width)};
  padding: 0 2rem 0 0;
  text-align: ${props => props.textAlign};

  &:first-of-type {
    padding-left: 2rem;
  }
`;

export const Separator = styled('td')`
  padding: 1.4rem 2rem 1.5rem;
  font-size: 1.3rem;
  color: ${Colors.rgbaBlack40};
  text-transform: uppercase;
  letter-spacing: 0.071em;

  &:before {
    content: '';
    display: block;
    height: 0;
    margin-bottom: 2.3rem;
    border-top: 1px solid ${Colors.rgbaBlack10};
  }
`;
